"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornVerticalNavigationBar = void 0;
var react_1 = __importDefault(require("react"));
var AcornFeatureContainer_1 = require("../AcornFeatureContainer");
var authentication_1 = require("../authentication");
var AcornVerticalNavigationGroup_1 = require("./AcornVerticalNavigationGroup");
var AcornVerticalNavigationBar = function () {
    return (react_1.default.createElement(AcornFeatureContainer_1.AcornFeatureContainerContext.Consumer, null, function (featureContext) {
        if (featureContext.menu) {
            return (react_1.default.createElement("ul", { className: "c-nav +primary" }, Object.values(featureContext.menu).map(function (menuItem) {
                var group = (react_1.default.createElement(AcornVerticalNavigationGroup_1.AcornVerticalNavigationGroup, { name: menuItem.name, path: menuItem.path, icon: menuItem.icon, children: Object.values(menuItem.children) }));
                if (menuItem.requiredPermissions && menuItem.requiredPermissions.length > 0) {
                    return (react_1.default.createElement(authentication_1.GuardedContainer, { requiredPermissions: menuItem.requiredPermissions }, group));
                }
                else {
                    return group;
                }
            })));
        }
    }));
};
exports.AcornVerticalNavigationBar = AcornVerticalNavigationBar;
//# sourceMappingURL=AcornVerticalNavigationBar.js.map